const RAW_API_BASE = process.env.REACT_APP_API_URL || "";
const API_BASE = RAW_API_BASE.replace(/\/+$/, "").replace(/\/api$/, "");

export function resolveAvatarUrl(avatarUrl) {
    if (!avatarUrl) {
        return null;
    }
    if (/^https?:\/\//i.test(avatarUrl)) {
        return avatarUrl;
    }
    const path = avatarUrl.startsWith("/") ? avatarUrl : `/${avatarUrl}`;
    return `${API_BASE}${path}`;
}
